import PropTypes from 'prop-types';
import React, {useContext, useEffect, useRef, useState} from 'react';

import Select, {SelectItem} from '../ui/Select';
import ApplicationContext from "../ApplicationContext";
import {IsoCountryParams} from "../fms.core/constants";


interface IIsoCountry {
  text: string,
  value:string,
}

function IcoCountryDropDown({
                            value,
                            onChange = () => {},
                            disabled = false,
                            name=undefined,
                            maxLength=undefined,
                          }: {
  maxLength?: number|undefined,
  name?:string|undefined,       
  value: string|null|undefined,
  disabled?: boolean,
  onChange?: (x:IIsoCountry|null) => void,
}) {
  const appContext = useContext(ApplicationContext);

  const [data, _setData] = useState<Array<any>>([]);
  const dataRef = useRef<Array<IIsoCountry>>([]);

  function setData(d: Array<IIsoCountry>){
    dataRef.current = d;
    _setData(d);
  }

  async function fetchData(api:any) {
    const data = await api.loadCodeData([new IsoCountryParams()]);
    if(data && data.length > 0) {
      setData(data[0].items);
    }
  }

  useEffect(() => {
      fetchData(appContext.api);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  function handleChange(e:React.ChangeEvent<HTMLInputElement>) {
    if (!e.target.value) {
      onChange(null);
      return;
    }

    onChange(dataRef.current?.find(d => d.value === e.target.value) || null);
  }

  const displayData:Array<SelectItem> = [
    ...data.map(x => ({ value: x.value ?? '', label: x.value ?? '' }))
  ];

  return (
    <Select
      name={name}
      maxLength={maxLength}
      value={(value === null || value === undefined) ? '' : value}
      onChange={handleChange}
      disabled={disabled}
      items={displayData}
    />
  );
}

IcoCountryDropDown.defaultProps = {
  onChange: () => {},
  disabled: false,
  dark: false,
};

IcoCountryDropDown.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  dark: PropTypes.bool.isRequired,
};

export default React.memo(IcoCountryDropDown);
